import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { authsApi } from "@/lib/api";
import type { AuthCreate, AuthUpdate } from "@/types";

export function useAuths() {
  return useQuery({
    queryKey: ["auths"],
    queryFn: () => authsApi.list(),
  });
}

export function useAuth(id: string) {
  return useQuery({
    queryKey: ["auths", id],
    queryFn: () => authsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateAuth() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AuthCreate) => authsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["auths"] }),
  });
}

export function useUpdateAuth() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: AuthUpdate }) =>
      authsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["auths"] }),
  });
}

export function useDeleteAuth() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => authsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["auths"] }),
  });
}
